export default __webpack_public_path__ + "static/RestaurantHER-dd54216ca22aaa74bd392d5f3d3a992f.png";